export default class Role{
    constructor(id,name) {
        this.id=id;
        this.name=name;
    }
}